import FetchStatusRepository                from "../../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyMessage                        from "../../../../domain/fundamentals/message/notify/NotifyMessage";
import NotifyRepository                     from "../../../../domain/fundamentals/message/notify/NotifyRepository";
import NotifyType                           from "../../../../domain/fundamentals/message/notify/NotifyType";
import ReservationHistoryRepository         from "../../../../domain/reservation/history/ReservationHistoryRepository";
import ReservationId                        from "../../../../domain/reservation/ReservationId";
import FetchStatusDataSource
                                            from "../../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import NotifyDataSource                     from "../../../../infrastructure/datasource/notify/NotifyDataSource";
import ReservationHistoryDataSource
                                            from "../../../../infrastructure/datasource/reservation/history/ReservationHistoryDataSource";
import GetCancelRequestedReservationHistory from "../history/GetCancelRequestedReservationHistory";
import GetCountRequestedCancelStatus        from "./GetCountRequestedCancelStatus";

class AcceptReservationCancelRequest {
  constructor(
    private readonly dispatch,
    private readonly repository: ReservationHistoryRepository = new ReservationHistoryDataSource(),
    private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(dispatch),
    private readonly notifyRepository: NotifyRepository = new NotifyDataSource(dispatch),
    private readonly getCancelRequestReservationHistory = new GetCancelRequestedReservationHistory(dispatch),
    private readonly getCountRequestedCancelStatus = new GetCountRequestedCancelStatus(dispatch),
  ) {
  }

  public async execute(reservationId: ReservationId): Promise<void> {
    this.fetchStatusRepository.start();
    try {
      await this.repository.acceptCancelRequest(reservationId);
      this.getCancelRequestReservationHistory.execute();
      this.getCountRequestedCancelStatus.execute();
      this.notifyRepository.optionalMessage(NotifyType.SAVE_SUCCESS, new NotifyMessage("予約キャンセル依頼を確定しました。"));
    } catch (e) {
      this.notifyRepository.optionalMessage(NotifyType.SAVE_SUCCESS, new NotifyMessage("予約キャンセル依頼を確定できませんでした。"));
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default AcceptReservationCancelRequest;
